import { CustomFieldsState } from "./types";

export function getDefaultState(): CustomFieldsState {
	return {
		areaCustomFields: [],
		contactCustomFields: [],
		alarmCustomFields: [],
		deviceCustomFields: [],
		serverCustomFields: [],
		notificationTemplateCustomFields: [],
		totalAreaCustomFields: 0,
		totalContactCustomFields: 0,
		totalAlarmCustomFields: 0,
		totalServerCustomFields: 0,
		totalDeviceCustomFields: 0,
		totalNotificationTemplateCustomFields: 0
	};
}
